import React from 'react';
import AdminPaymentRecord from "../../components/admin/components/AdminPaymentRecord";

const PaymentRecord = () => {
    return <AdminPaymentRecord />;
};

export default PaymentRecord;
